module.exports = __webpack_public_path__ + "img/chair.cda0faa7.png";